<template>
    <modal name="update_user" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update user')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-input id="name" v-model="form.name" name="name" rules="required">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-input>
                    <app-input id="email" v-model="form.email" name="email" rules="required|email" type="email">
                        <template #label>
                            {{ $t('Email') }}*
                        </template>
                    </app-input>
                    <app-select id="roles"
                                v-model="form.roles"
                                :options="roles.map(c => c.id)"
                                name="roles"
                                rules="required"
                                searchable
                                multiple
                                not-empty
                                closeOnSelect
                                :custom-label="id => roles.some(c => c.id === id) ? roles.find(c => c.id === id).name : null">
                        <template #label>
                            {{ $t('Roles') }}*
                        </template>
                    </app-select>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import UserService from '@services/user.service';
import RoleService from '@services/role.service';

export default {
    data() {
        return {
            form: {},
            roles: [],
            loading: false,
            user_id: null
        };
    },
    methods: {
        getRoles() {
            RoleService.roles().then(res => this.roles = res);
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    UserService.update(this.user_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setUser', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const user = event.params.user;
            if (user) {
                this.form.name = user.name;
                this.form.email = user.email;
                this.form.roles = user.roles.map(r => r.id);
                this.user_id = user.id;
            }
        },
        hide() {
            this.$modal.hide('update_user');
        }
    },
    created() {
        this.getRoles();
    }
};
</script>
